var generator = function () {
    if (self.crypto.randomUUID) {
        return self.crypto.randomUUID();
    }
    var classicGenerator = Math.floor((Date.now() +
        (Math.floor(Math.random() * 982347500) + 1) +
        Date.now() * Date.now()) /
        (Math.floor(Math.random() * 400) + 1));
    return "".concat(classicGenerator);
};
export default generator;
